import React from 'react';
import { useToast } from '../../components/ui';

/*
 * withToast — inject the toast API as a `toast` prop into a (class) component.
 * The Setup panes are connected class components, so they can't call the
 * useToast hook directly; this HOC bridges the ToastProvider context to a prop.
 * Requires a <ToastProvider> ancestor (mounted in AdminScreen).
 */
export default function withToast(Component) {
  const Wrapped = (props) => {
    const toast = useToast();
    return <Component {...props} toast={toast} />;
  };
  Wrapped.displayName = `withToast(${Component.displayName || Component.name || 'Component'})`;
  return Wrapped;
}
